var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.Stack,{staticClass:"new-ai-job"},[_c(_setup.Title,[_vm._v("Create a new AI Job")]),_vm._v(" "),_c(_setup.JobForm,{attrs:{"form":_setup.form,"loading":_setup.isSubmitting},on:{"submit":_setup.handleSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }